import { useState, useEffect } from "react";

export default function useTelegram() {
  const [isTelegram, setIsTelegram] = useState(false);
  const [tg, setTg] = useState(null);
  const [userId, setUserId] = useState(null);

  useEffect(() => {
    if (window.Telegram?.WebApp) {
      const telegram = window.Telegram.WebApp;
      
      // Inicjalizacja Telegram WebApp
      telegram.ready();
      
      setTg(telegram);
      setIsTelegram(true);
      
      // Pobieranie ID użytkownika
      const id = telegram.initDataUnsafe?.user?.id || null;
      setUserId(id);

      // Użycie showAlert tylko jeśli ID jest dostępne
    //  if (id) {
       // telegram.showAlert(`Twoje Telegram ID: ${id}`);
   //   } else {
    //    console.warn("Nie udało się pobrać ID użytkownika.");
    //  }
    } else {
      setIsTelegram(false);
    }
  }, []);

  const onClose = () => {
    if (tg) tg.close();
  };

  const getUserId = () => userId;

  return {
    isTelegram,
    tg,
    onClose,
    getUserId,
  };
}
